// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"216":"94e18db2","373":"7107bc6d"}[chunkId] + ".chunk.js";
};